<input #topAnchor matInput type="text" [readonly]="true" class="discoveryProcess_hiddenInput">
<div class="discoveryWizard_container">
    <div *ngIf="questionList.length > 0" class="discoveryWizard_currentQuestionContainer">
        <app-discovery-wizard-current-question *ngIf="questionList[currentQuestionPos].type==eDiscoveryQuestionTypeEnum.Standard" class="discoveryWizard_currentQuestion" 
            [ngClass]="{'is-mobile-view': isMobileView || isMediumResolutionView}"
            [isLoading] = isLoading
            [currentQuestion]="questionList[currentQuestionPos]" 
            [presentConsultantVideo]="presentConsultantQuestionsVideo"
            (sendQuestionResponseEvent)=setQuestionResponse($event)>
        </app-discovery-wizard-current-question>
        <app-discovery-wizard-current-question-gap *ngIf="questionList[currentQuestionPos].type==eDiscoveryQuestionTypeEnum.MotivationGap" class="discoveryWizard_currentQuestion" 
            [ngClass]="{'is-mobile-view': isMobileView || isMediumResolutionView}"
            [isLoading] = isLoading
            [currentQuestion]="questionList[currentQuestionPos]" 
            (sendQuestionResponseEvent)=setQuestionMotivationResponse($event)>
        </app-discovery-wizard-current-question-gap>
        <app-discovery-wizard-current-question-tail *ngIf="questionList[currentQuestionPos].type==eDiscoveryQuestionTypeEnum.TailResolution" class="discoveryWizard_currentQuestion" 
            [ngClass]="{'is-mobile-view': isMobileView || isMediumResolutionView}"
            [isLoading] = isLoading
            [currentQuestion]="questionList[currentQuestionPos]"
            [presentConsultantVideo]="presentConsultantQuestionsVideo" 
            (sendQuestionResponseEvent)=setQuestionTailResponse($event)>
        </app-discovery-wizard-current-question-tail>
    </div>
    <div class="discoveryChat_footer">
        <app-progress-bar
            class="discoveryProcess_progessBar"
            [value]="progressBarValue"
            [showBackdrop]="false"
            [compact]="true"
        ></app-progress-bar>
    </div>
</div>